//
// Handles unarchive Student when user clicks "unarchive" from "options" dropdown
//
// TO THINK: this is almost a duplicate as archive-student. It's against the DRY.
// Should we do somehting about it? Or just keep it this way for simplicity?
//
import { confirm } from "util/confirm";

export default function ({trData: studentToUnarchive}) {
  let { sName } = studentToUnarchive;

  confirm(__('Proceed to restore student: {name}？', 'student' , {name: sName}), __('Restore', 'teacher'))
    .then(()=>{
      const {
        schoolStudentID
      } = studentToUnarchive;

      let {
        fetchStudent,
        unarchiveStudent,
      } = this.props.student;

      unarchiveStudent('@unarchive-student', schoolStudentID)

		})
		.catch((err)=>{
			console.log(err);
		});
}



// WEBPACK FOOTER //
// ./src/containers/pages/Student/unarchive-student.js